var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.43188,
    y: 0.833344,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8069 12.8333C13.8069 12.4191 13.4711 12.0833 13.0569 12.0833C12.6427 12.0833 12.3069 12.4191 12.3069 12.8333H13.8069ZM12.3069 20.3333C12.3069 20.7476 12.6427 21.0833 13.0569 21.0833C13.4711 21.0833 13.8069 20.7476 13.8069 20.3333H12.3069ZM11.1819 8.33334V9.08334H18.6819V8.33334V7.58334H11.1819V8.33334ZM20.9319 10.5833H20.1819V18.0833H20.9319H21.6819V10.5833H20.9319ZM18.6819 20.3333V19.5833H11.1819V20.3333V21.0833H18.6819V20.3333ZM8.93188 18.0833H9.68188V10.5833H8.93188H8.18188V18.0833H8.93188ZM11.1819 20.3333V19.5833C10.3535 19.5833 9.68188 18.9118 9.68188 18.0833H8.93188H8.18188C8.18188 19.7402 9.52503 21.0833 11.1819 21.0833V20.3333ZM20.9319 18.0833H20.1819C20.1819 18.9118 19.5103 19.5833 18.6819 19.5833V20.3333V21.0833C20.3387 21.0833 21.6819 19.7402 21.6819 18.0833H20.9319ZM18.6819 8.33334V9.08334C19.5103 9.08334 20.1819 9.75492 20.1819 10.5833H20.9319H21.6819C21.6819 8.92649 20.3387 7.58334 18.6819 7.58334V8.33334ZM11.1819 8.33334V7.58334C9.52503 7.58334 8.18188 8.92649 8.18188 10.5833H8.93188H9.68188C9.68188 9.75492 10.3535 9.08334 11.1819 9.08334V8.33334ZM13.0569 12.8333H12.3069V20.3333H13.0569H13.8069V12.8333H13.0569ZM9.30688 12.4583V13.2083H20.5569V12.4583V11.7083H9.30688V12.4583Z",
    fill: "#825DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisCircle);
export default __webpack_public_path__ + "static/media/analysis-circle.6311cc84acb5d89e93b701d1f5d32da9.svg";
export { ForwardRef as ReactComponent };